import { ProductSubDepartmentDetailPage } from '@/features/product-sub-department/pages/ProductSubDepartmentDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product-sub-department/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_sub_department.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductSubDepartmentDetailPage,
})
